import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { NoteService } from 'app/modules/vehicle-inventory/services/note.service';
import { Rest } from 'app/rest/rest_client';
import { VehicleService } from 'app/rest/vehicle.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { RestExt } from 'app/services/rest-client-extension';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';

@Component({
    selector: 'app-notes-form',
    templateUrl: './notes-form.component.html',
    styleUrls: ['./notes-form.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NotesFormComponent extends EntityFormComponent<Rest.InvNote>
implements OnInit{

  @Input() vehicle?: Rest.Vehicle = null;
  title: string;
  ids: number[] = [];

  active: boolean;
  formManipulation: boolean;
  vehicleRequestContext: Rest.ListPaginationRequest;
  vehicleList: Rest.Vehicle[] = [];
  documentFile: any;
  downloadGranted: boolean = false;
  noteDate: Date;
  loading:boolean;
  constructor(
      private noteService: NoteService,
      notificationsService: NotificationsService,
      protected i18n: I18nService,
      private authenticationService: AuthenticationService,
      private translate: TranslateService,
      private vehicleService: VehicleService,
      private datePipe: DatePipe,
      private userTime: UserTimePipe

  ) {
      super(noteService, notificationsService, i18n, authenticationService);
  }

  ngOnInit(): void {
    this.vehicleRequestContext = RestExt.firstPageRequest();
		this.vehicleRequestContext.filters['clientId'] = [this.authenticationService.user.client.id.toString()];
    this.setPermissions();
  }

  /**
  * Loads and evaluates all the necessary data before showing the form.
  *
  * @memberof RentingTypeFormComponent
  */
  beforeShow() {
    this.ids = [];
    if (this.entity.documents && this.entity.documents.length > 0) {
			this.entity.documents.forEach((x) => this.ids.push(x.id));
		} else {
			this.ids = [-1];
		}

      this.active = !this.entity.disabled;
      this.loading = false;
      if (this.isNew) {
          this.title = this.translate.instant('tableManagement.notes.createNotes');
      } else {
          this.title = this.translate.instant('tableManagement.notes.updateNotes');
      }

      if (this.vehicle) {
        this.entity.vehicle = this.vehicle;
      }

      this.vehicleRequestContext = {
        sortBy: 'name',
        sortAsc: true,
        filters:{},
        pageSize:10
      } as unknown as Rest.ListPaginationRequest;
  
      if(this.entity.vehicle){
        this.vehicleRequestContext.filters["name"] = [this.entity.vehicle.name];
      }

      this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
        this.vehicleList = p.entities;
      });

      this.noteDate = this.entity.noteDate ? this.userTime.utcToCalendarDate(this.entity.noteDate) : null;
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_NOTE_CREATE', 'INV_NOTE_UPDATE'];
    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    this.downloadGranted = this.authenticationService.isRoleGranted('INV_NOTE_READ', user);
  }

  onChangeVehicle(event) {
		this.entity.vehicle = event.value;
	}

	onFilterVehicle(event) {
		this.vehicleRequestContext = {
			sortBy: 'name',
			sortAsc: true,
			pageSize:10,
			filters:{}
		} as unknown as Rest.ListPaginationRequest;
		this.vehicleRequestContext.filters["name"] = [event.filter ?? ''];
		this.vehicleService.getPage(this.vehicleRequestContext).then((p) => {
			this.vehicleList = p.entities;
		});
	}

  validateNote() {
		// console.log("[DOC-FORM] validateNote *** ");
		// console.log(this.note);
		if (!this.entity.description || !this.entity.noteDate)  {
			return false;
		} else {
			return true;
		}
	}

  public createNote() {
    
    this.entity.noteDate= this.noteDate;
		if (this.validateNote()) {
      this.loading = true;
      
			//let dataString = JSON.stringify(this.entity);

				const promise = new Promise<void>((resolve, reject) => {
					const that = this;
					this.noteService
						.createNote(this.entity)
						.then(
							function (response) {
								// console.log("==> create document... " + that.type);
								// console.log(response);
								that.entity = response;
                that.loading = false;
                that.isNew = false;
								that.return.emit(response);
                
							},
							/* failure */
							function (error) {
								console.log('The request failed: ' + error);
                that.loading = false;
								resolve();
                
							},
						)
						.catch(function (reason) {
							console.log('Catched: ' + reason);
              that.loading = false;
							resolve();
              
						});
				});

			}else{
        this.notificationsService.add(Severity.warn,"",this.translate.instant('error.required-field.generic'))
      }

    }

    public updateNote() {
      
      this.entity.noteDate= this.noteDate;
      if (this.validateNote()) {
      
        this.loading = true;
        //let dataString = JSON.stringify(this.entity);
  
          const promise = new Promise<void>((resolve, reject) => {
            const that = this;
            this.noteService
              .updateNote(this.entity)
              .then(
                function (response) {
                  // console.log("==> create document... " + that.type);
                  // console.log(response);
                  that.entity = response;
                  that.display = false;
                  that.loading = false;
                  that.return.emit(response);
                },
                /* failure */
                function (error) {
                  console.log('The request failed: ' + error);
                  that.loading = false;
                  resolve();
                },
              )
              .catch(function (reason) {
                console.log('Catched: ' + reason);
                that.loading = false;
                resolve();
              });
          });
  
        }else{
          this.notificationsService.add(Severity.warn,"",this.translate.instant('error.required-field.generic'))
        }
  
      }

      /*downloadFile() {
        // console.log("[DOC-FORM] downloadFile ***");
        // console.log(this.entity);
        if ((!this.downloadGranted) ||(!this.entity.document)) {
          return;
        }
    
        var imageEncoded = this.entity.document.document.imageEncoded;
		    const contentToReplace = imageEncoded.split(',')[0] + ',';
		    const byteCharacters = atob(imageEncoded.replace(contentToReplace, ''));
		    const mime = imageEncoded.split(':')[1].split(';')[0];
		    const byteNumbers = new Array(byteCharacters.length);

		    for (let i = 0; i < byteCharacters.length; i++) {
			    byteNumbers[i] = byteCharacters.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    const blob = new Blob([byteArray], { type: mime });
		    const decodedName = decodeURIComponent(this.entity.document.document.name);  // Decode URI to avoid %20 
		    // save the blob using the FileSaver module
		    saveAs(blob, decodedName);
      }*/
}
